import React from 'react';
import { disableAutocompleteProps, getTravellerName, getUserValue } from '../../../../utils';
import { Field } from 'react-final-form';
// import { Select } from '../../../../Passenger/components/Field/Select/Select';
import Input from '../../../../BaseComponents/Input';
import { PassengerFragment, TravellerFieldEnum } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import { useConfig } from '../../../../context';
import { useTranslation } from 'react-i18next';
import { LoyaltyCardTypes } from '../../../types';

interface Props {
	traveller: PassengerFragment;
	loyaltyCardTypes?: LoyaltyCardTypes[];
}

const TravellerFields: React.FC<Props> = ({ traveller, loyaltyCardTypes }) => {
	const theme = useTheme('Loyalty').LinkCardsModal;
	const { t } = useTranslation('LinkCardsModal');

	const FFPRegex = useConfig().global.FFPRegex;
	// const iataCode = useConfig().global.companyInfo.iataCode;

	const testFFP = (value: string) => {
		if (value && !FFPRegex.test(value)) {
			return t('CustomerContactsForm:Please enter a valid FFP');
		} else {
			return undefined;
		}
	};

	// const cardTypesList = React.useMemo(() => {
	// 	if (loyaltyCardTypes?.length) {
	// 		return loyaltyCardTypes;
	// 	}
	//
	// 	return [{ key: LoyaltyCardsType.IndividualCard, value: t('Individual loyalty card') }];
	// }, [loyaltyCardTypes]);

	const loyaltyNumber = getUserValue(traveller, TravellerFieldEnum.LoyaltyNumber);
	// const isDisabledCardTypes = iataCode !== 'B2' || !!loyaltyNumber;

	const disabled = !!loyaltyNumber;

	return (
		<div className={theme.traveller}>
			<div className={theme.traveller__name}>{getTravellerName(traveller)}</div>

			<div className={theme.traveller__fields}>
				{/*<Field*/}
				{/*	name={`travellers[${traveller.id}].loyaltyCardType`}*/}
				{/*	render={({ input, meta }) => (*/}
				{/*		<Select*/}
				{/*			{...input}*/}
				{/*			className={theme.traveller__select}*/}
				{/*			classes={{*/}
				{/*				input: theme.input,*/}
				{/*				input_disabled: theme.input_disabled*/}
				{/*			}}*/}
				{/*			disabled={isDisabledCardTypes}*/}
				{/*			options={cardTypesList}*/}
				{/*			variant={'filled'}*/}
				{/*			selectFirstOptionByDefault={true}*/}
				{/*			error={(meta.error || meta.submitError) && meta.touched && t('Error')}*/}
				{/*			label={null}*/}
				{/*		/>*/}
				{/*	)}*/}
				{/*/>*/}

				<Field
					name={`travellers[${traveller.id}].loyaltyCardNumber`}
					defaultValue={loyaltyNumber}
					validate={!disabled ? testFFP : undefined}
					render={({ input, meta }) => (
						<Input
							{...input}
							className={theme.traveller__input}
							error={(meta.error || meta.submitError) && meta.touched && !disabled}
							helperText={(meta.error || meta.submitError) && meta.touched && !disabled && meta.error}
							value={!!loyaltyNumber ? loyaltyNumber : input.value}
							disabled={disabled}
							label={t('Enter a card number')}
							FormHelperTextProps={{
								classes: {
									root: theme.helperText
								}
							}}
							{...disableAutocompleteProps}
						/>
					)}
				/>
			</div>
		</div>
	);
};

export default TravellerFields;
